import { useCallback } from 'react'
import { useTranslate } from '@/utils/translate/translate-client'
import { OptionGroup } from '../../components/OptionGroup'

interface Props {
  isFullFilm: boolean
  disabled?: boolean
  value: 'true' | 'false' | undefined
  onChange: ({ name, value }: { name: string; value: boolean }) => void
}

export const FullFilmDistributionQuestion = ({ disabled, value, onChange, isFullFilm = false }: Props) => {
  const { t } = useTranslate('guild-create')

  const handleChange = useCallback(
    (value: string[]) => {
      const [fullFilmDistributionValue] = value
      onChange({ name: 'hasFilmBeenDistributed', value: fullFilmDistributionValue === 'true' })
    },
    [onChange],
  )

  if (!isFullFilm) return null

  const options = [
    {
      label: t('yes', 'Yes'),
      value: 'true',
    },
    {
      label: t('no', 'No'),
      value: 'false',
    },
  ]

  return (
    <OptionGroup
      name="hasFilmBeenDistributed"
      label={t('hasFilmBeenDistributed', 'Has this film been distributed in any form commercially?')}
      options={options}
      required
      disabled={disabled}
      value={value ? [value] : []}
      onChange={handleChange}
      limit={1}
    />
  )
}
